import type { FeatureFlags } from '@/lib/api';

export interface PortalNavItem {
  labelKey: string;
  path: string;
  icon: string;
  badge?: string;
  /** раздел фазы 2: показывается только при включённом фичефлаге */
  flag?: keyof FeatureFlags;
}

export const portalNav: PortalNavItem[] = [
  { labelKey: 'portal.nav.home', path: '/portal', icon: 'ri-home-5-line' },
  { labelKey: 'portal.nav.products', path: '/portal/products', icon: 'ri-armchair-line' },
  { labelKey: 'portal.nav.upload', path: '/portal/upload', icon: 'ri-upload-cloud-2-line', flag: 'portal_upload' },
  { labelKey: 'portal.nav.demand', path: '/portal/demand', icon: 'ri-bar-chart-2-line', flag: 'demand' },
  { labelKey: 'portal.nav.reservations', path: '/portal/reservations', icon: 'ri-calendar-check-line' },
  { labelKey: 'portal.nav.orders', path: '/portal/orders', icon: 'ri-shopping-bag-3-line' },
  { labelKey: 'portal.nav.finance', path: '/portal/finance', icon: 'ri-wallet-3-line' },
  { labelKey: 'portal.nav.warranty', path: '/portal/warranty', icon: 'ri-shield-check-line', flag: 'warranty_ui' },
  { labelKey: 'portal.nav.contract', path: '/portal/contract', icon: 'ri-file-text-line' },
  { labelKey: 'portal.nav.team', path: '/portal/team', icon: 'ri-team-line' },
];

export const visiblePortalNav = (flags: FeatureFlags) => portalNav.filter((i) => !i.flag || flags[i.flag]);

export const mobileTabPaths = ['/portal', '/portal/products', '/portal/reservations', '/portal/orders'];

export const findPortalNavKey = (pathname: string): string => {
  if (pathname.startsWith('/portal/feedback')) return 'fb.myTitle';
  const match = portalNav
    .filter((item) => item.path !== '/portal' && pathname.startsWith(item.path))
    .sort((a, b) => b.path.length - a.path.length)[0];
  if (match) return match.labelKey;
  return 'portal.nav.home';
};
